import React from "react";
import { Link, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { resolveAiArtwork } from "../../services/artworkResolver";
import { useAiArtwork } from "../../hooks/useAiArtwork";
import { useArtworkDocumentMeta } from "../../hooks/useArtworkDocumentMeta";
import { artworkPagePath } from "../../lib/artworkPaths";
import { ArtworkDetailLayout } from "./ArtworkDetailLayout";
import { RelatedArtworksSection } from "../RelatedArtworksSection";

export function AiArtworkPage() {
  const { t } = useTranslation();
  const { id = "" } = useParams();
  const work = resolveAiArtwork(id);

  if (!work) {
    return (
      <div className="section-container py-24 text-center">
        <h1 className="font-display text-3xl text-canvas-950">
          {t("common.artworkNotFound")}
        </h1>
        <Link to="/gallery?tab=ai" className="btn-primary mt-6">
          {t("common.backToGallery")}
        </Link>
      </div>
    );
  }

  return <AiArtworkPageContent work={work} />;
}

function AiArtworkPageContent({ work }: { work: NonNullable<ReturnType<typeof resolveAiArtwork>> }) {
  const translated = useAiArtwork(work);

  useArtworkDocumentMeta({
    title: `${translated.title} | Shanir Arts`,
    description: translated.description,
    imageUrl: translated.imageUrl,
    canonicalPath: artworkPagePath("ai", work.id),
  });

  return (
    <ArtworkDetailLayout
      medium="ai"
      artworkId={work.id}
      artworkName={translated.name}
      eyebrow={translated.collectionLabel}
      title={translated.title}
      description={translated.description}
      imageUrl={translated.imageUrl}
      imageAlt={translated.name}
      footer={
        <RelatedArtworksSection
          medium="ai"
          currentId={work.id}
          collection={work.collection}
          collectionLabel={translated.collectionLabel}
        />
      }
    />
  );
}
